import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FinancialCalculator } from '../pages/FinancialCalculator'
import { Simulation } from '../pages/Simulation'
import Top from '../pages/Top'
import Kyouiku from '../pages/Kyouiku'
import Shisan from '../pages/Shisan'
import Rougo from '../pages/Rougo'
import Toushin from '../pages/Toushin'
import Tsumitate from '../pages/Tsumitate'
import NotFound from '../pages/NotFound'
import { CalcReversal } from '../pages/CalcReversal'
// import { FinancialCalcReversal } from '../pages/FinancialCalcReversal'
import { RougoSimulation } from '../pages/RougoSimulation'
import { IframeSimulation } from '../pages/IframeSimulation'
import { IframeCalcReversal } from '../pages/IframeCalcReversal'
import { IframeFinancialCalculator } from '../pages/IframeFinancialCalculator'
import { IframeRougoSimulation } from '../pages/IframeRougoSimulation'
import { IframeFinancialCalcReversal } from '../pages/IframeFinancialCalcReversal'

export function Routes() {
  return (
    <Switch>
      <Route path="/kyouiku" component={Kyouiku} />
      <Route path="/shisan" component={Shisan} />
      <Route path="/rougo" component={Rougo} />
      <Route path="/toushin" component={Toushin} />
      <Route path="/tsumitate" component={Tsumitate} />
      <Route path="/calc" component={FinancialCalculator} />
      <Route path="/simulation" component={Simulation} />
      <Route path="/reversal" component={CalcReversal} />
      {/* <Route path="/calcReversal" component={FinancialCalcReversal} /> */}
      <Route path="/rougoSimulation" component={RougoSimulation} />
      <Route path="/notfound" component={NotFound} />

      <Route path="/module/calc" component={IframeFinancialCalculator} />
      <Route path="/module/simulation" component={IframeSimulation} />
      <Route path="/module/reversal" component={IframeCalcReversal} />
      <Route path="/module/calcReversal" component={IframeFinancialCalcReversal} />
      <Route path="/module/rougoSimulation" component={IframeRougoSimulation} />

      <Route path="/:dealerCode/kyouiku" component={Kyouiku} />
      <Route path="/:dealerCode/shisan" component={Shisan} />
      <Route path="/:dealerCode/rougo" component={Rougo} />
      <Route path="/:dealerCode/toushin" component={Toushin} />
      <Route path="/:dealerCode/tsumitate" component={Tsumitate} />
      <Route path="/:dealerCode/calc" component={FinancialCalculator} />
      <Route path="/:dealerCode/simulation" component={Simulation} />
      <Route path="/:dealerCode/rougoSimulation" component={RougoSimulation} />
      <Route path="/:dealerCode/notfound" component={NotFound} />
      <Route path="/:dealerCode/" component={Top} />
      <Route path="/" component={Top} />
      <Redirect to="/" />
    </Switch>
  )
}
